<template>
    <div :class="notification.data.classes.bubble">
        <component
            :is="notification.data.icon"
            :class="notification.data.classes.icon"
            class="shrink-0 w-4.5 h-4.5 mt-0.5"
        />
    </div>

    <div class="w-full pl-2.5 text-white">
        <p class="text-15 font-semibold">
            {{ notification.data.title }}
        </p>
        <p class="text-13 text-grey-700">
            {{ notification.data.description }}
        </p>
        <div class="flex items-center justify-between pt-2">
            <NuxtLink
                no-prefetch
                v-for="(link, text) in notification.data.links"
                :key="text"
                :to="link"
                class="underline text-12"
                data-close
                v-text="text"
            />

            <p class="text-12 text-grey-800">
                {{ $moment(notification.created_at).format('HH:mm') }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
};
</script>
